import { configureStore } from '@reduxjs/toolkit';
import {
  frontdeskReducer,
  emrReducer,
  medicationsReducer,
  soapOrderCacheReducer,
  // CRM reducers
  crmReducer,
  leadsReducer,
  crmPatientsReducer,
  crmTasksReducer,
  crmFormsReducer,
  crmEventsReducer,
  appointmentsReducer,
  userManagementReducer,
} from './slices';

export const store = configureStore({
  reducer: {
    // Existing
    frontdesk: frontdeskReducer,
    emr: emrReducer,
    medications: medicationsReducer,
    soapOrderCache: soapOrderCacheReducer,
    // CRM
    crm: crmReducer,
    leads: leadsReducer,
    crmPatients: crmPatientsReducer,
    crmTasks: crmTasksReducer,
    crmForms: crmFormsReducer,
    crmEvents: crmEventsReducer,
    appointments: appointmentsReducer,
    userManagement: userManagementReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
